import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RedirectState } from "./AnonymousRoute";
import { routes } from "modules/common/routes";

/**
 * Обёртка вокруг содержимого маршрута, доступного только вошедшим.
 * Неавторизованного отправляет на «/login», запоминая, откуда его развернули.
 *
 * В react-router 5 это был отдельный `<Route>` со своим `render`. В шестой версии
 * маршрут описывается объектом, а его `element` — обычным деревом компонентов,
 * поэтому проверка прав переехала из маршрута внутрь элемента.
 */
export const ProtectedRoute = ({ loggedIn, children }: ProtectedRouteProps) => {
    const location = useLocation();

    if (!loggedIn) {
        const state: RedirectState = { from: location.pathname };

        return <Navigate to={routes.login} state={state} replace={true} />;
    }

    return <>{children}</>;
};

interface ProtectedRouteProps {
    loggedIn: boolean;
    children?: React.ReactNode;
}
